import React, { useEffect, useRef, useState } from "react";
import Image from "../../../assets/images/logo.png";
import { useParams } from "react-router-dom";
import axios from "axios";
import Apiurl from "../../environment/Apiurl";
import { FaMobileAlt, FaEnvelope, FaHome } from "react-icons/fa";

const Invoice_JobSheetBill = () => {
  const hasPrinted = useRef(false);
  const { id } = useParams();
  const [getData, setGetData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${Apiurl}/job-sheet/${id}`);
      setGetData(response.data || []);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  useEffect(() => {
    if (!getData || hasPrinted.current) return;
    const timer = setTimeout(() => window.print(), 800);
    window.onafterprint = () => {
      hasPrinted.current = true;
    };
    return () => clearTimeout(timer);
  }, []);

  const handleBack = () => window.history.back();

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const terms = [
    "From the date of repair and maintenance, Service Centres will safe keep your equipment for a period of 60 days.",
    "If the device is not collected within 60 days, the service centre will not be responsible for its damage or loss.",
    "We have the right to handle the equipment and take necessary action for disposal process in accordance with the applicable laws.",
  ];

  const services = getData.complaint_details || [];

  const BillContent = () => (
    <div className="bill-a5 bg-white p-3 d-flex flex-column">
      {/* ── HEADER ── */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="fw-bold mb-0" style={{ fontSize: "22px" }}>
            WE CARE
          </h5>
          <h6 className="fw-bold mb-2" style={{ fontSize: "16px" }}>
            AUTHORIZED SERVICE CENTER
          </h6>
          <div style={{ fontSize: "14px", lineHeight: "1.6" }}>
            <div>
              <FaHome /> No 113 & 114, Light House Complex,
            </div>
            <div className="ms-2">Omalur Main Road, 4 Roads, Salem-636009</div>
            <div>
              <FaMobileAlt /> +91-9123514823 | +91 8124909380
            </div>
            <div>
              <FaEnvelope /> wecare.slm22@gmail.com
            </div>
          </div>
        </div>
        <div>
          <img
            src={Image}
            alt="logo"
            style={{ maxHeight: "70px", width: "auto" }}
          />
        </div>
      </div>

      <div
        className="text-center fw-bold mb-2"
        style={{
          fontSize: "18px",
          borderBottom: "1px solid #a7a7a7",
          paddingBottom: "4px",
          width: "100%",
          textAlign: "center",
        }}
      >
        JOB SHEET
      </div>

      {/* ── CUSTOMER INFO + JOB SHEET ── */}

      <div
        className="d-flex justify-content-between mb-3"
        style={{ fontSize: "14px", gap: "15px" }}
      >
        <div style={{ flex: 1 }}>
          <div
            className="fw-bold mb-2"
            style={{
              fontSize: "18px",
              borderBottom: "1px solid #a7a7a7",
              paddingBottom: "4px",
              width: "40%",
            }}
          >
            Customer Info
          </div>
          <div style={{ fontSize: "14px" }}>
            <strong>{getData.customer_name || "N/A"}</strong>
          </div>
          <div style={{ fontSize: "16px" }}>
            {getData.mobile_number || "N/A"}
          </div>
          <div style={{ fontSize: "16px" }}>
            {getData.customer_address || "N/A"}
          </div>
          <div className="mt-2" style={{ fontSize: "16px" }}>
            <strong>Brand :</strong> {getData.mobile_brand || "N/A"} <b>|</b>{" "}
            <strong>Model :</strong> {getData.mobile_model || "N/A"}
          </div>
          <div style={{ fontSize: "14px" }}>
            <strong>IMEI:</strong> {getData.mobile_imei || "N/A"}
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <br></br>

          <div style={{ fontSize: "16px" }}>
  <div className="d-flex mb-1">
    <span style={{ width: "140px" }}>Job Sheet No</span>
    <span style={{ width: "15px", textAlign: "center" }}>:</span>
    <strong>{getData.sheet_no}</strong>
  </div>

  <div className="d-flex mb-1">
    <span style={{ width: "140px" }}>Date</span>
    <span style={{ width: "15px", textAlign: "center" }}>:</span>
    <span>{formatDate(getData.date)}</span>
  </div>

  <div className="d-flex mb-1">
    <span style={{ width: "140px" }}>Time</span>
    <span style={{ width: "15px", textAlign: "center" }}>:</span>
    <span>{getData.time || "N/A"}</span>
  </div>

  <div className="d-flex mb-1">
    <span style={{ width: "140px" }}>CCO</span>
    <span style={{ width: "15px", textAlign: "center" }}>:</span>
    <span>{getData.customer_care_officer || "N/A"}</span>
  </div>

  <div className="d-flex">
    <span style={{ width: "140px" }}>Warranty</span>
    <span style={{ width: "15px", textAlign: "center" }}>:</span>
    <span>{getData.warranty_status || "N/A"}</span>
  </div>
</div>
        </div>
      </div>

      <hr style={{ borderTop: "1px solid #ddd", margin: "5px 0" }} />

      {/* ── COMPLAINTS TABLE ── */}
      <div style={{ fontSize: "14px", marginBottom: "16px" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <td
                className="fw-bold"
                style={{
                  padding: "7px 10px",
                  border: "1px solid #000",
                  backgroundColor: "#f0f0f0",
                  fontSize: "18px",
                }}
              >
                Complaints
              </td>
            </tr>
          </thead>
          <tbody>
            {services.length > 0 ? (
              services.map((item, i) => (
                <tr key={i}>
                  <td
                    style={{
                      padding: "7px 10px",
                      border: "1px solid #000",
                      verticalAlign: "top",
                    }}
                  >
                    <div style={{ fontSize: "16px" }}>
                      <span className="fw-bold">
                        {item.complaint_name || "N/A"}
                      </span>
                      {/* <span>{item.complaint_no || "N/A"}</span> */}
                    </div>
                    <div style={{ marginTop: "4px", fontSize: "15px" }}>
                      <span className="fw-bold">Notes : </span>
                      {item.complaint_notes || "N/A"}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  style={{
                    padding: "8px",
                    border: "1px solid #000",
                    textAlign: "center",
                  }}
                >
                  N/A
                </td>
              </tr>
            )}
            <tr>
              <td
                style={{
                  padding: "7px 10px",
                  border: "1px solid #000",
                  fontSize: "15px",
                }}
              >
                <span className="fw-bold">Appearance status : </span>
                {getData.apperance_status || "N/A"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr style={{ borderTop: "1px solid #ddd", margin: "5px 0" }} />

      {/* ── TERMS ── */}
      <div style={{ flex: 0.6, marginBottom: "2px" }}>
        <div className="fw-bold mb-2" style={{ fontSize: "17px" }}>
          Terms and Conditions:
        </div>
        <ul
          style={{
            margin: 0,
            paddingLeft: "20px",
            fontSize: "13px",
            lineHeight: "1.7",
          }}
        >
          {terms.map((t, i) => (
            <li key={i} style={{ marginBottom: "6px", fontSize: "13px" }}>
              {t}
            </li>
          ))}
        </ul>
      </div>

      {/* ── SIGNATURES ── */}
      <div className="signatures row" >
        <div className="col-6" style={{ width: "50%" }}>
          <div
            style={{
              borderTop: "1px solid #000",
              paddingTop: "6px",
              display: "inline",
            }}
          >
            <span style={{ fontSize: "13px" }}>Customer Signature</span>
          </div>
        </div>
        <div className="col-6 text-end" style={{ width: "50%" }}>
          <div
            style={{
              borderTop: "1px solid #000",
              paddingTop: "6px",
              display: "inline",
            }}
          >
            <span style={{ fontSize: "13px" }}>
              For: WE CARE AUTHORIZED SERVICE CENTER
            </span>
            <div className="mt-4 me-5">
              <span style={{ fontSize: "13px", fontWeight: "bold" }}>
                Authorized Signatory
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ── FOOTER ── */}
      <p
        className="text-center mt-4 mb-0"
        style={{ fontSize: "11px", color: "#696666" }}
      >
        --- Developed By Aalantechsoft - Salem ---
      </p>
    </div>
  );

  return (
    <>
      {/* Back Button */}
      <div
        className="d-flex justify-content-start mb-2 d-print-none mt-2 mx-5 sticky-top"
        style={{ top: "10px" }}
      >
        <button className="btn btn-secondary btn-sm" onClick={handleBack}>
          Back
        </button>
      </div>

      {/* First Copy */}
      <div className="d-flex justify-content-center align-items-start bg-light mt-1 screen-wrapper">
        <BillContent />
      </div>

      {/* Second Copy */}
      <div className="justify-content-center align-items-start bg-light mt-1 screen-wrapper second-page">
        <BillContent />
      </div>

      <style>{`
        .screen-wrapper {
          min-height: 100vh;
          padding: 15px 0;
          background-color: #f8f9fa;
        }

        .bill-a5 {
          width: 210mm;
          min-height: 297mm;
          height: 297mm;
          box-sizing: border-box;
          box-shadow: 0 0 10px rgba(0,0,0,0.15);
          background-color: white;
        }

        .second-page {
          display: none;
        }

        @media print {
          @page {
            size: A4 portrait;
            margin: 5mm;
          }

          * {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          html, body {
            margin: 0;
            padding: 0;
          }

          .d-print-none {
            display: none !important;
          }

          .screen-wrapper {
            background: none !important;
            padding: 0 !important;
            margin: 0 !important;
            min-height: auto !important;
            display: block !important;
          }

          .second-page {
            display: block !important;
          }

          .signatures {
            margin-top: 80px !important;
          }

          .bill-a5 {
            width: 100% !important;
            height: 100vh !important;
            min-height: auto !important;
            box-shadow: none !important;
            padding: 8mm !important;
            margin: 0 !important;
            box-sizing: border-box !important;
            page-break-after: always !important;
            break-after: always !important;
          }
        }
      `}</style>
    </>
  );
};

export default Invoice_JobSheetBill;
